import { findUserById } from '@src/main/modules/user/application/find-user-by-id.usecase';
import { createUserHttpRepository } from '@src/main/modules/user/infrastructure/UserHttpRepository';

export const fetchUserById = async (token: string, id: string) => {
  const getToken = async () => token;
  const repository = createUserHttpRepository({ getToken });
  return await findUserById(repository, id);
};
